import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, HostListener, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { EventService } from 'src/app/service/event.service';
import { PIEvent } from 'src/app/service/events';
import { AFPersonalInformation, AF_CONSTANTS } from 'src/app/model/af.model';
import { KeyValue } from '@angular/common';
import { BaseComponent } from 'src/app/base-component';
import { Router } from '@angular/router';
import { CustomValidatorsService } from 'src/app/service/custom-validators.service';
import { MatSelectionListChange } from '@angular/material/list';

@Component({
    selector: 'app-other-name',
    templateUrl: './other-name.component.html',
    styleUrls: ['./other-name.component.scss'],
    standalone: false
})
export class OtherNameComponent extends BaseComponent implements OnInit, AfterViewInit {

  maxDate = new Date();
  minDate = new Date(1900, 0, 1);
  submitted: boolean = false;
  step: number = 0;
  otherNameChange: boolean = false;
  listCheck: boolean = false;
  border: boolean = false;
  shiftButton: boolean = false;

  @Input() piData: AFPersonalInformation;
  @Input() show: boolean;

  @ViewChild("addElement") addElement: ElementRef;
  @ViewChild("addButtonElement") addButtonElement: ElementRef;

  regexName: RegExp = /^[A-Za-z\u00C0-\u017F\-',. ]+$/;

  constructor(private readonly fb: UntypedFormBuilder, private readonly eventBus: EventService, private readonly cd: ChangeDetectorRef, private readonly router: Router, private readonly customValidator: CustomValidatorsService) {
    super(eventBus, router);
  }

  otherNameform = this.fb.group({
    otherNameList: new UntypedFormArray([])
  });

  setStep(index: number) {
    this.step = index;
  }

  ngOnInit() {
    this.eventBus.on(
      PIEvent,
      (event): void => {
        this.piData = event.payload.piData;
        for (let otherName of this.piData.otherNameList) {
          let fg: UntypedFormGroup = this.fieldsGroup();
          fg.patchValue(otherName);
          this.otherNameList.push(fg);
        }
        if (this.otherNameList.length == 0) {
          this.createComponent();
        }
      }
    );
  }

  ngAfterViewInit() {
    this.otherNameform.valueChanges.subscribe(() => {
      if (this.otherNameList.length != 0) {
        this.listCheck = true;
      } else {
        this.listCheck = false;
      }
    });

    this.handleZoom();
  }

  get otherFormControls() { return this.otherNameform.controls; }
  get otherNameList() { return this.otherFormControls.otherNameList as UntypedFormArray; }

  fieldsGroup(): UntypedFormGroup {
    const fg: UntypedFormGroup = this.fb.group({
      otherFirstName: ['', [Validators.required, Validators.maxLength(50), this.customValidator.validateRequiredField, Validators.pattern(this.regexName)]],
      nameType: ['', [Validators.required]],
      otherMiddleName: ['', [Validators.maxLength(50), Validators.pattern(this.regexName)]],
      otherLastName: ['', [Validators.required, Validators.maxLength(50), this.customValidator.validateRequiredField, Validators.pattern(this.regexName)]]
    });
    if (this.piData.jobCountryValue === 'India') { //restrict required
      fg.addControl('dateNameChange', this.fb.control('', Validators.maxLength(100)));
    } else {
      fg.addControl('dateNameChange', this.fb.control('', [Validators.maxLength(100), Validators.required]));
    }
    return fg;
  }

  onAddOtherName() {
    setTimeout(() => {
      this.addElement.nativeElement.focus();
      this.border = true;
    });
    this.createComponent();
  }

  createComponent() {
    this.otherNameList.push(this.fieldsGroup());
    this.step = this.otherNameList.length - 1;
  }

  validate() {
    return this.otherNameform.invalid;
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:load', ['$event'])
  handleZoom() {
    const windowWidth = window.innerWidth;
    if (windowWidth <= AF_CONSTANTS.windowWidth) {
      this.otherNameChange = true;
    } else {
      this.otherNameChange = false;
    }

    if (windowWidth <= 375) {
      this.shiftButton = true;
    } else {
      this.shiftButton = false;
    }
  }

  handleSelection(event: MatSelectionListChange) {
    event.source.deselectAll();
    event.options[0].selected = true;
    this.step = event.options[0].value;
  }

  dropDownScreenReaderNameType(other: any): string {
    if (other.controls.nameType.value) {
      return 'Selected ' + this.piData.nameTypeLookup[Object.keys(this.piData.nameTypeLookup).find(e => e === other.controls.nameType.value)];
    } else {
      return 'blank';
    }
  }

  deleteClick(i) {
    this.otherNameList.removeAt(i);
    if (i == this.otherNameList.length) {
      this.step = i - 1;
    }
    this.cd.detectChanges();

    setTimeout(() => {
      if (this.otherNameList && this.otherNameList.length == 0) {
        this.addButtonElement.nativeElement.focus();
        this.border = false;
      } else {
        this.addElement.nativeElement.focus();
        this.border = true;
      }
    });
  }

  focusTarget() {
    setTimeout(() => {
      this.addElement.nativeElement.focus();
      this.border = true;
    });
  }

  @HostListener('document:keydown', ['$event'])
  clearBorder(keyDown: KeyboardEvent) {
    if (keyDown.key === 'Tab') {
      this.border = false;
    }
  }

  @HostListener('click', ['$event'])
  clearBorderClick() {
    this.border = false;
  }

  valueAscOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.value.localeCompare(b.value);
  }
}